/* @flow */
import * as React from 'react';
import styled from '@emotion/styled';

type Props = {
  src: string
};

const StyledImg = styled.img({
  verticalAlign: 'top',
  width: '100%',
  height: '100%'
});

const Wrapper = styled.div({
  width: '1em',
  height: '1em'
});

function PayoutIndicator({ src }: Props) {
  return (
    <Wrapper>
      <StyledImg src={src} alt="" />
    </Wrapper>
  );
}

export default PayoutIndicator;
